module.exports = __webpack_public_path__ + "img/timeline_mainevent-7.86829708.jpg";